import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { SessionService } from '../session/session.service';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(
    private apiService: ApiService,
    private session: SessionService
  ) {}

  public cifInquiryV2(customerId: string, isEntity: boolean): Observable<any> {
    const url = `${isEntity ? '/v1/account/business/cif/inquiry' : '/v2/account/cifinquiry'}`;
    return this.apiService.post<any>(url, {
      BankId: this.session.user.bankId,
      CustomerID: customerId,
    });
  }

  public getGLAccount(values: string): Observable<any> {
    const url = '/v1/glaccount/details/' + values;
    return this.apiService.get<any>(url);
  }

  public getAccount(values: string): Observable<any> {
    const url = '/v1/account' + values;
    return this.apiService.get<any>(url);
  }

  public fetchPhoto(data: any): Observable<any> {
    const url = '/v1/account/photo';
    return this.apiService.post<any>(url, data);
  }

  public getDataDRC(bankId: string): Observable<any> {
    const url = `/v1/backoffice/StaticDataUpdatePersonal/populate-dropdown?bankId=${bankId}`;
    return this.apiService.get<any>(url);
  }

  public getPhysicalAddressUpdateRequired(
    customerId: string,
    bankId: string,
    customerType: 'Retail' | 'Corporate'
  ): Observable<any> {
    const url = `/v4/account/physical-address/required/${customerId}`;

    return this.apiService.get<any>(url, {
      queryParams: {
        customerId,
        bankId,
        customerType,
      },
    });
  }
  public getCities(data: any): Observable<any> {
    const url = '/v1/account/cities';
    return this.apiService.post<any>(url, data);
  }
}
